import { environmentHttpClient } from "client/Api/httpClient";
import { formatForDto } from "client/DateAndTime/dateTimeUtils";
import { TimeZone } from "client/DateAndTime/timezones";

export type BirthdayListItem = {
	firstName: string;
	lastName: string;
	avatarId: string | null;
	upcomingBirthday: string;
	userId: number;
	canMakeWish: boolean;
};

export function list(
	today: Date,
	page: number,
	timezone: TimeZone,
	signal?: AbortSignal
): Promise<LazyLoadPageResult<BirthdayListItem>> {
	return environmentHttpClient.get<LazyLoadPageResult<BirthdayListItem>>(
		"/Workspace/LiveInformation/Birthday",
		{
			// NOTE: we want the ISO format to contain the browser timezone
			// hence this weird construction of serializing it properly
			today: formatForDto(today, timezone),
			page
		},
		{ signal }
	);
}
